module.exports = __webpack_public_path__ + "static/media/icon-child-male.bed927c8.svg";